import React, { useEffect, useState } from 'react'
import { RankListRequestRef, ScoringRequest } from '../firebase/collections';
import { limit, onSnapshot, query, where, orderBy } from 'firebase/firestore';
import { useTranslate } from './TranslationText';

export default function CurrentClassRankTable({ showId = "", setNewUpdate = () => console.log('') }) {
    const { translate } = useTranslate();

    const [firestoreData, setFireStoreData] = useState([]);
    const currentLanguage = localStorage.getItem('ecupLang') ?? 'en';
    const [viewHorseBox, setViewHorseBox] = useState(false);
    const [inArenaHorse, setInArenaHorse] = useState([]);
    const [inArenaHorseId, setInArenaHorseId] = useState('');
    const filterScoring = async () => {
        const q = query(
            ScoringRequest,
            where("ShowId", "==", showId), 
            orderBy('TimeStamp', 'desc'),
            limit(1),
        );
        return q;
    }
    const filterCollection = async () => {
        const twentyMinutesAgo = new Date();
        twentyMinutesAgo.setMinutes(twentyMinutesAgo.getMinutes() - 20);
        const q = query(
            RankListRequestRef,
            where("ShowId", "==", showId), // Filter by AuctionHorseID
            where("TimeStamp", ">=", twentyMinutesAgo),
            orderBy('TimeStamp', 'desc'),
            limit(1),
        );
        return q;
    };
    const fetchData = async () => {
        try {
            const q = await filterCollection();

            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                const newData = [];

                querySnapshot.forEach((doc) => {
                    newData.push(doc.data());
                });
                setFireStoreData(newData[newData.length - 1]);
                setNewUpdate((prev) => prev + 1);
                console.debug('Scoring Data is', newData)
            });

            return unsubscribe;
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const fetchScoring = async () => {
        try {
            // Now, proceed to fetch data from Firestore
            const q = await filterScoring();
            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                const newData = [];
                querySnapshot.forEach((doc) => {
                    newData.push(doc.data());
                });

                setInArenaHorse((prev) => {
                    if (newData[0]?.Action == 5) {
                        if (prev[0]?.HorseId === newData[0].HorseId) {
                            return newData;
                        }
                    }
                    else if (newData[0]?.Action == 1) {
                        return newData;
                    }
                    return prev;
                });

            });

            return unsubscribe;
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const resetInArenaHorseIfRequired = (firestoreData, inArenaHorse) => {
        if (Array.isArray(inArenaHorse) && inArenaHorse.length > 0) {
            const currentInArenaHorse = inArenaHorse[0]?.TimeStamp?.seconds;
            const currentIncomingRankListUpdate = firestoreData?.TimeStamp?.seconds;
            if (currentIncomingRankListUpdate > currentInArenaHorse) {
                setViewHorseBox(false);
                setInArenaHorse([]);
            }
        }
    }
    useEffect(() => {
        fetchData();
        fetchScoring();
    }, [])
    useEffect(() => {
        if (inArenaHorse.length > 0) {
            if (inArenaHorse[0].Action == 1) {
                setInArenaHorseId(inArenaHorse[0].HorseId)
                setViewHorseBox(true);
            } else if (inArenaHorse[0]?.Action == 5) {
                if (inArenaHorseId === inArenaHorse[0]?.HorseId) {
                    setViewHorseBox(false);
                    setInArenaHorseId('');
                    setInArenaHorse([]);
                }
            }
        }
        resetInArenaHorseIfRequired(firestoreData, inArenaHorse)

    }, [firestoreData, inArenaHorse])

    return (
        <>
            {viewHorseBox && inArenaHorse.map((horse, index) => {
                return (
                    <div className='shadow  my-3 bg-white' style={{ borderRadius: 25 }}>
                        <div className="card-body text-center fw-bold pb-3">
                            <h5 className="card-title  fw-bold text-dark mb-1"> {translate("web.currentHorseInArena", "Current Horse In Arena")}</h5>
                            <div className='bg-secondary'  style={{width: 100, height: 100, color: 'white', borderRadius: '50%', fontSize: 32, display: 'inline-flex', alignItems: 'center', justifyContent: "center" }} >{horse?.HorseNumber}</div>
                            <h5 className="card-title mt-1  fw-bold text-dark"> {currentLanguage == 'en' ? horse?.HorseInArenaName : horse?.HorseInArenaNameAr}</h5>
                            <h5 className="card-title mt-1 fw-bold text-dark rtl">{currentLanguage == 'en' ? horse?.OwnerName : horse?.OwnerNameAr}</h5>
                        </div>
                    </div>
                )
            })}
            {!!firestoreData && firestoreData?.RankScoringList?.length > 0 && (
                <div
                    className="col-lg-12 col-md-12 col-sm-12 mt-1"
                >
                    <h4 className='roboto-custom-black fw-bold'>
                        {translate("web.currentClassRank", "Current class rank")} <br />
                        {currentLanguage == 'en' ? firestoreData?.ClassName : firestoreData?.ClassNameAr}
                    </h4>
                    <div className="table-container scrolableDiv" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                        <table
                            className="w-100 minWidth600 table table-striped table-bordered"
                            style={{ direction: currentLanguage == "ar" ? "rtl" : "ltr", width: '100%', minWidth: 0 }}
                        >
                            <thead className='bgDarkGray text-center' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                <tr>
                                    <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset' }}>
                                        {translate("web.rank", "Rank")}
                                    </th>
                                    <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset' }}>{translate("web.horseName", "Horse Name")}</th>
                                    <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset' }}>{translate('web.total', 'Total')}</th>
                                </tr>
                            </thead>
                            <tbody className='text-center'>
                                {firestoreData?.RankScoringList?.map((item, i) => (
                                    <tr key={i} style={{ tableLayout: 'fixed' }}>
                                        <td className='bold'>{item.HorseRank}</td>
                                        <td className='bold'>
                                            {item.HorseNumber} {item[`HorseName${currentLanguage == 'en' ? '' : 'Ar'}`]}
                                        </td>
                                        <td className='bold' >{item.TotalScore.toFixed(2)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}</>
    )
}
